import {
  dealGasRouteOrder
} from '@/cllib/sys_lib'

import {
  routerOrderOutPutMx,
  routerOrderMatchOrder,
  routerOrderOutPut,
  routerOrderOutPut2,
  routerOrderOutPutCar,
  routerOrderClearData,
  routerOrderInputData,
  routerOrderCount,
  groupGetData
} from '@/api/api'

const state = {
  gasRouterOrderList: [],
  gasRouterOrderTotal: 0,
  matchLoading: false,
  matchDate: null,
  openMatchResult: false
}

const getters = {
  gasRouterOrderList: state => state.gasRouterOrderList,
  gasRouterOrderTotal: state => state.gasRouterOrderTotal,
  matchLoading: state => state.matchLoading,
  matchDate: state => state.matchDate,
  openMatchResult: state => state.openMatchResult
}

const actions = {
  loadGasRouterOrderList ({ dispatch }, parm) {
    return routerOrderOutPutMx(parm).then((data) => {
      dispatch('setGasRouterOrderList', dealGasRouteOrder(data))
    })
  },
  routerOrderCount ({ dispatch }, parm) {
    return routerOrderCount(parm)
  },
  routerOrderClearData ({ dispatch }, parm) {
    return routerOrderClearData(parm)
  },
  routerOrderInputData ({ dispatch }, parm) {
    return routerOrderInputData(parm)
  },
  routerOrderOutPut ({ dispatch }, parm) {
    return routerOrderOutPut(parm)
  },
  routerOrderOutPut2 ({ dispatch }, parm) {
    return routerOrderOutPut2(parm)
  },
  routerOrderOutPutCar ({ dispatch }, parm) {
    return routerOrderOutPutCar(parm)
  },
  matchOrder ({ dispatch }, parm) {
    dispatch('setMatchLoading', true)
    dispatch('setMatchDate', parm.sendTime)
    return routerOrderMatchOrder(parm).then((data) => {
      dispatch('getMatchStatus')
    }).catch(() => {
      dispatch('setMatchLoading', false)
    })
  },
  getMatchStatus ({ dispatch, getters }) {
    setTimeout(function () {
      groupGetData().then((data) => {
        let ok = true
        data.forEach((item) => {
          if (item.id === getters.currentGroupId) {
            ok = ['N', 'E'].includes(item.planMatchStatus)
          }
        })
        if (!ok) {
          dispatch('getMatchStatus')
        } else {
          dispatch('loadAllOrder', getters.searchOrderParm)
          dispatch('loadSignCar', getters.searchSignCarParm)
          dispatch('setMatchLoading', false)
          dispatch('setOpenMatchResult', true)
          dispatch('showNoticeMsg', {type: 'success', title: '系统提示', message: '匹配完成！'})
        }
      }).catch(() => {
        dispatch('setMatchLoading', false)
      })
    }, 5000)
  },
  setMatchLoading ({ commit }, data) {
    commit('setMatchLoading', data)
  },
  setGasRouterOrderList ({ commit }, data) {
    commit('setGasRouterOrderList', data)
  },
  setGasRouterOrderTotal ({ commit }, data) {
    commit('setGasRouterOrderTotal', data)
  },
  setMatchDate ({ commit }, data) {
    commit('setMatchDate', data)
  },
  setOpenMatchResult ({ commit }, data) {
    commit('setOpenMatchResult', data)
  }
}

const mutations = {
  setGasRouterOrderList (state, data) {
    state.gasRouterOrderList = data
  },
  setGasRouterOrderTotal (state, data) {
    state.gasRouterOrderTotal = data
  },
  setMatchLoading (state, data) {
    state.matchLoading = data
  },
  setMatchDate (state, data) {
    state.matchDate = data
  },
  setOpenMatchResult (state, data) {
    state.openMatchResult = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/gas_router_order.js